// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui.dimmer[data-v-45db7a2a] {\n    background-color: rgba(0,0,0,.05) !important;\n}\n.supervised-person-manager-modal-header[data-v-45db7a2a] {\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
